const m = (engines) => engines;

export const CARS = {
  Volkswagen: {
    Golf: m(["1.0 TSI", "1.4 TSI", "1.5 TSI", "2.0 TSI GTI", "2.0 TSI R", "1.6 TDI", "2.0 TDI"]),
    Polo: m(["1.0 TSI", "1.2 TSI", "1.4 TDI", "1.6 TDI", "2.0 TSI GTI"]),
    Passat: m(["1.4 TSI", "1.8 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI", "2.0 BiTDI"]),
    Tiguan: m(["1.4 TSI", "2.0 TSI", "2.0 TDI", "2.0 BiTDI"]),
    Touareg: m(["3.0 V6 TDI", "4.2 V8 TDI", "3.0 V6 TSI"]),
    Transporter: m(["2.0 TDI", "2.0 BiTDI", "2.5 TDI"]),
    Caddy: m(["1.6 TDI", "2.0 TDI", "1.4 TSI"]),
    Crafter: m(["2.0 TDI", "2.0 BiTDI", "2.5 TDI"]),
    Amarok: m(["2.0 TDI", "2.0 BiTDI", "3.0 V6 TDI"]),
  },
  Audi: {
    A3: m(["1.4 TFSI", "1.5 TFSI", "1.8 TFSI", "2.0 TFSI", "1.6 TDI", "2.0 TDI", "S3 2.0 TFSI"]),
    A4: m(["1.8 TFSI", "2.0 TFSI", "2.0 TDI", "3.0 TDI", "S4 3.0 TFSI"]),
    A5: m(["2.0 TFSI", "2.0 TDI", "3.0 TDI"]),
    A6: m(["2.0 TFSI", "2.0 TDI", "3.0 TDI", "3.0 BiTDI", "3.0 TFSI"]),
    Q3: m(["1.4 TFSI", "1.5 TFSI", "2.0 TFSI", "2.0 TDI"]),
    Q5: m(["2.0 TFSI", "2.0 TDI", "3.0 TDI"]),
    Q7: m(["3.0 TDI", "4.2 TDI", "3.0 TFSI"]),
  },
  Skoda: {
    Fabia: m(["1.0 TSI", "1.2 TSI", "1.4 TDI", "1.6 TDI"]),
    Octavia: m(["1.0 TSI", "1.4 TSI", "1.5 TSI", "2.0 TSI RS", "1.6 TDI", "2.0 TDI"]),
    Superb: m(["1.4 TSI", "1.8 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI"]),
    Kodiaq: m(["1.5 TSI", "2.0 TSI", "2.0 TDI", "2.0 BiTDI"]),
    Karoq: m(["1.0 TSI", "1.5 TSI", "1.6 TDI", "2.0 TDI"]),
  },
  BMW: {
    "1-serie": m(["116d", "118d", "120d", "118i", "120i", "M135i"]),
    "3-serie": m(["318d", "320d", "330d", "335d", "320i", "330i", "340i"]),
    "5-serie": m(["518d", "520d", "525d", "530d", "535d", "520i", "530i", "540i"]),
    X1: m(["sDrive18d", "xDrive20d", "xDrive25d", "sDrive20i"]),
    X3: m(["xDrive20d", "xDrive30d", "xDrive35d", "xDrive20i", "xDrive30i"]),
    X5: m(["xDrive25d", "xDrive30d", "xDrive40d", "M50d", "xDrive40i"]),
  },
  "Mercedes-Benz": {
    "A-klasse": m(["A160d", "A180d", "A200d", "A180", "A200", "A250"]),
    "C-klasse": m(["C200d", "C220d", "C250d", "C300d", "C180", "C200", "C300"]),
    "E-klasse": m(["E200d", "E220d", "E250d", "E350d", "E200", "E300"]),
    GLC: m(["GLC 220d", "GLC 250d", "GLC 300d", "GLC 300"]),
    "GLE / ML": m(["250d", "350d", "400d"]),
    Vito: m(["1.6 CDI", "2.1 CDI", "2.0 CDI (OM654)", "3.0 V6 CDI"]),
    Sprinter: m(["2.1 CDI", "2.0 CDI (OM654)", "3.0 V6 CDI"]),
  },
  Volvo: {
    V40: m(["D2", "D3", "D4", "T2", "T3", "T4"]),
    "V60 / S60": m(["D2", "D3", "D4", "D5", "T4", "T5", "T6"]),
    "V70 / XC70": m(["D3", "D4", "D5", "T4", "T5"]),
    "V90 / S90": m(["D4", "D5", "T5", "T6"]),
    XC40: m(["D3", "D4", "T3", "T4", "T5"]),
    XC60: m(["D3", "D4", "D5", "T5", "T6"]),
    XC90: m(["D4", "D5", "T5", "T6"]),
  },
  Toyota: {
    Hilux: m(["2.4 D-4D", "2.5 D-4D", "2.8 D-4D", "3.0 D-4D"]),
    "Land Cruiser": m(["2.8 D-4D", "3.0 D-4D", "4.5 V8 D-4D"]),
    RAV4: m(["2.0 D-4D", "2.2 D-4D", "2.0 VVT-i"]),
    Auris: m(["1.4 D-4D", "2.0 D-4D", "1.2 Turbo", "1.6 VVT-i"]),
    Avensis: m(["2.0 D-4D", "2.2 D-4D", "1.8 VVT-i"]),
    "Proace / Hiace": m(["1.6 D", "2.0 D", "2.5 D-4D", "3.0 D-4D"]),
  },
  Ford: {
    Focus: m(["1.0 EcoBoost", "1.5 EcoBoost", "1.5 TDCi", "2.0 TDCi", "ST 2.0 EcoBoost"]),
    Mondeo: m(["1.5 EcoBoost", "2.0 EcoBoost", "2.0 TDCi"]),
    Kuga: m(["1.5 EcoBoost", "2.0 EcoBoost", "1.5 TDCi", "2.0 TDCi"]),
    Transit: m(["2.0 EcoBlue", "2.2 TDCi", "2.4 TDCi"]),
    "Transit Custom": m(["2.0 EcoBlue", "2.2 TDCi"]),
    Ranger: m(["2.2 TDCi", "3.2 TDCi", "2.0 EcoBlue"]),
  },
  Peugeot: {
    "208": m(["1.2 PureTech", "1.6 BlueHDi", "1.5 BlueHDi"]),
    "308": m(["1.2 PureTech", "1.6 THP", "1.6 BlueHDi", "2.0 BlueHDi"]),
    "3008": m(["1.2 PureTech", "1.6 THP", "1.5 BlueHDi", "2.0 BlueHDi"]),
    "Partner / Expert": m(["1.6 HDi", "1.6 BlueHDi", "2.0 BlueHDi"]),
  },
  Nissan: {
    Qashqai: m(["1.2 DIG-T", "1.3 DIG-T", "1.5 dCi", "1.6 dCi"]),
    "X-Trail": m(["1.6 dCi", "2.0 dCi"]),
    Navara: m(["2.3 dCi", "2.5 dCi", "3.0 V6 dCi"]),
  },
  Mitsubishi: {
    L200: m(["2.2 DI-D", "2.4 DI-D", "2.5 DI-D"]),
    Outlander: m(["2.2 DI-D", "2.0", "2.4"]),
  },
  "Land Rover": {
    "Range Rover": m(["3.0 TDV6", "3.0 SDV6", "4.4 SDV8", "3.0 D300"]),
    "Range Rover Sport": m(["3.0 TDV6", "3.0 SDV6", "4.4 SDV8", "3.0 D300"]),
    "Range Rover Evoque": m(["2.0 TD4", "2.2 SD4", "2.0 Si4"]),
    Discovery: m(["2.0 SD4", "3.0 TDV6", "3.0 SDV6"]),
    Defender: m(["2.2 TD4", "2.4 TD4", "2.0 D240", "3.0 D300"]),
  },
  Porsche: {
    Cayenne: m(["3.0 V6 Diesel", "4.2 V8 Diesel", "3.0 V6", "4.0 V8 Turbo"]),
    Macan: m(["2.0", "3.0 V6 S", "3.0 V6 Diesel", "2.9 V6 GTS"]),
  },
  Hyundai: {
    i30: m(["1.0 T-GDi", "1.4 T-GDi", "1.6 CRDi", "2.0 T-GDi N"]),
    Tucson: m(["1.6 T-GDi", "1.7 CRDi", "2.0 CRDi"]),
    "Santa Fe": m(["2.2 CRDi", "2.0 CRDi"]),
  },
  Kia: {
    Ceed: m(["1.0 T-GDi", "1.4 T-GDi", "1.6 CRDi"]),
    Sportage: m(["1.6 T-GDi", "1.7 CRDi", "2.0 CRDi"]),
    Sorento: m(["2.2 CRDi", "2.0 CRDi"]),
  },
  Opel: {
    Astra: m(["1.4 Turbo", "1.6 Turbo", "1.6 CDTI", "2.0 CDTI"]),
    Insignia: m(["1.6 Turbo", "2.0 Turbo", "1.6 CDTI", "2.0 CDTI"]),
    Vivaro: m(["1.6 CDTI", "2.0 CDTI"]),
  },
  Renault: {
    Megane: m(["1.3 TCe", "1.5 dCi", "1.6 dCi"]),
    Trafic: m(["1.6 dCi", "2.0 dCi"]),
    Master: m(["2.3 dCi"]),
  },
};

export const MAKES = Object.keys(CARS);
const NOW = new Date().getFullYear();
export const YEARS = Array.from({ length: NOW - 1995 + 2 }, (_, i) => String(NOW + 1 - i));
export const OTHER = "__other";
